import {
  Http
} from '../utils/http.js';
class Everybody extends Http {
  productTypeList(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Everybody/AuthorProductList",
      method: "post",
      param:param
    })
  }

  productByType(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Everybody/EverybodyList",
      method: "post",
      param: param
    })
  }

 
}
export {
  Everybody
}